import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { useTranslation } from "@/i18n/LanguageContext";

export default function NotFoundPage() {
    const { t } = useTranslation();
    return (
        <div data-testid="not-found-page" className="container-x section-y text-center max-w-xl">
            <SEO title={t("notFound.seo.title")} description={t("notFound.seo.description")} path="/404" />
            <p className="label-eyebrow">404</p>
            <h1 className="mt-5 text-5xl font-heading text-ink">
                {t("notFound.heading")}
            </h1>
            <p className="mt-5 text-ink-soft leading-relaxed">
                {t("notFound.body")}
            </p>
            <Link
                to="/"
                data-testid="not-found-home-link"
                className="mt-8 inline-flex items-center rounded-full bg-terracotta text-cream font-semibold px-6 py-3 hover:bg-terracotta-hover transition-colors"
            >
                {t("notFound.cta")}
            </Link>
        </div>
    );
}
